import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid basic_table" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexBootstrap',
  setup(__props) {

const basicTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/basicTable.vue"))
const inverseTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/inverseTable.vue"))
const hoverableTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/hoverableTable.vue"))
const primaryBackground = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/primaryBackground.vue"))
const captionTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/captionTable.vue"))
const headOptions = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/headOptions.vue"))
const stripedRow = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/stripedRow.vue"))
const breckpointSpecific = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/breckpointSpecific.vue"))
const responsiveTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/responsiveTable.vue"))
const sizingTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/sizingTable.vue"))
const customTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/customTable.vue"))
const dashedBorder = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/dashedBorder.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bootstrap Tables",
      title: "Bootstrap Basic Tables"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(basicTable)),
        _createVNode(_unref(inverseTable)),
        _createVNode(_unref(hoverableTable)),
        _createVNode(_unref(primaryBackground)),
        _createVNode(_unref(captionTable)),
        _createVNode(_unref(headOptions)),
        _createVNode(_unref(stripedRow)),
        _createVNode(_unref(breckpointSpecific)),
        _createVNode(_unref(responsiveTable)),
        _createVNode(_unref(sizingTable)),
        _createVNode(_unref(customTable)),
        _createVNode(_unref(dashedBorder))
      ])
    ])
  ], 64))
}
}

})